import { render, staticRenderFns } from "./TicketAside.vue?vue&type=template&id=287606f2&scoped=true&"
import script from "./TicketAside.vue?vue&type=script&lang=js&"
export * from "./TicketAside.vue?vue&type=script&lang=js&"
import style0 from "./TicketAside.vue?vue&type=style&index=0&id=287606f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287606f2",
  null
  
)

export default component.exports